var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframeWrap",style:(_vm.lineStyle)},[_c('div',{staticClass:"iframe_mask"}),_c('iframe',{staticClass:"iframe",attrs:{"frameborder":"0","width":_vm.width,"height":_vm.height,"src":_vm.url,"scrolling":_vm.scrolling}})])}
var staticRenderFns = []

export { render, staticRenderFns }